import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Modal, Space } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import React from 'react';

import type { EdutainmentApplication } from '../../types';

const { confirm } = Modal;

const showReleaseConfirm = (record: EdutainmentApplication) => {
  confirm({
    title: '確定上架育樂活動？',
    icon: <ExclamationCircleOutlined rev={undefined} />,
    content: '上架後會員可在app上看到該育樂活動',
    centered: true,
    onOk() {
      // TODO: 邏輯待寫
      console.log('上架:', record);
    },
  });
};

const showDeleteConfirm = (record: EdutainmentApplication) => {
  confirm({
    title: '確定刪除育樂活動？',
    icon: <ExclamationCircleOutlined rev={undefined} />,
    content: '刪除後須重新提交申請!!',
    centered: true,
    okText: '刪除',
    okType: 'danger',
    onOk() {
      // TODO: 邏輯待寫
      console.log('刪除:', record);
    },
  });
};

export const getTableColumns = () => {
  const columns: ColumnsType<EdutainmentApplication> = [
    {
      title: '育樂名稱',
      dataIndex: 'name',
    },
    {
      title: '所屬計費方案',
      dataIndex: 'plans',
      width: 300,
      render: (plans: string[]) => {
        return plans.join('/');
      },
    },
    {
      title: '育樂類別',
      dataIndex: 'category',
    },
    {
      title: '自動上架日期(年/月/日)',
      dataIndex: 'autoReleaseDate',
      render: (releaseDate: number | null) => {
        return releaseDate
          ? dayjs(releaseDate).format('YYYY/MM/DD HH:mm:ss')
          : null;
      },
      sorter: (a, b) => {
        if (!a.autoReleaseDate || !b.autoReleaseDate) {
          return 0;
        }
        return a.autoReleaseDate - b.autoReleaseDate;
      },
    },
    {
      title: '育樂開始日期(年/月/日)',
      dataIndex: 'startDate',
      render: (startDate: number) => {
        return dayjs(startDate).format('YYYY/MM/DD');
      },
      sorter: (a, b) => a.startDate - b.startDate,
    },
    {
      title: '育樂結束日期(年/月/日)',
      dataIndex: 'endDate',
      render: (endDate: number) => {
        return dayjs(endDate).format('YYYY/MM/DD');
      },
      sorter: (a, b) => a.endDate - b.endDate,
    },
    {
      title: '育樂時間',
      dataIndex: 'times',
      width: 300,
      render: (times: string[]) => {
        return times.join('/');
      },
    },
    {
      title: '育樂主管',
      dataIndex: 'administrator',
    },
    {
      title: '講師',
      dataIndex: 'teacher',
    },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      render: (_, record) => {
        return (
          <Space>
            <Button type="primary" onClick={() => console.log('查看:', record)}>
              查看
            </Button>
            <Button onClick={() => showReleaseConfirm(record)}>上架</Button>
            <Button
              type="primary"
              danger
              onClick={() => showDeleteConfirm(record)}
            >
              刪除
            </Button>
          </Space>
        );
      },
    },
  ];
  return columns;
};
